<script>

    export let item

    export let styleClass = 'user-color-text'

    let path;

    if(item.p){
        path = item.p
        
    }else{
        
        if(item.iconFont !== undefined){
            path = item.iconFont
        }
        if(item.iconfont !== undefined){
            path = item.iconfont
        }
    }

</script>

<svg x='0px' y='0px' viewBox='0 0 200 200' class="{styleClass}" >
    {@html path}
</svg>

<style>

svg {
    width:30px;
    height:30px;
    margin:10px;
}
</style>